import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient, type MerchantScopedRequest} from "../../connection/BlinkApiClient.js";
import type {StoreId} from "../../../stem-core/state/State";
import {MerchantUser} from "./MerchantUserStore";
import {UserProfile} from "../UserProfileStore";
import {Merchant} from "../MerchantStore";
import {StemDate} from "../../../stem-core/time/Date";

@globalStore
export class MerchantStaff extends BaseStore("MerchantStaff", {dependencies: ["MerchantUser"]}) {
    @field(Number) merchantId: number;
    @field("Merchant") merchant: Merchant;
    @field("UserProfile") user: UserProfile;
    @field(Date) createdAt: StemDate;
    // @field(Date) lastModifiedAt; // TODO add in backend and her
    @field("UserProfile") createdBy: UserProfile;
    @field(Boolean) isOwner: boolean;
    @field(Boolean) hasEditPermissions: boolean;

    getMerchantUser(): MerchantUser {
        return MerchantUser.getFromObject(this);
    }

    getEmail(): string {
        return this.getMerchantUser().email;
    }
}

// MerchantCreateStaff (api/merchants/views.py). createIfRequired makes the user account when the address
// has none yet
export interface MerchantCreateStaffRequest extends MerchantScopedRequest {
    emailAddress: string;
    hasEditPermissions: boolean;
    createIfRequired: boolean;
    name?: string;
}

export async function apiMerchantCreateStaffMember(request: MerchantCreateStaffRequest): Promise<any> {
    return apiClient.post("/merchant/create_staff_member", request);
}

// MerchantEditStaff
export interface MerchantEditStaffRequest extends MerchantScopedRequest {
    staffId: StoreId;
    hasEditPermissions: boolean;
}

export async function apiMerchantEditStaffMember(request: MerchantEditStaffRequest): Promise<any> {
    return apiClient.post("/merchant/edit_staff_member", request);
}

// MerchantStaffRequest, the id on its own
export interface MerchantStaffRequest extends MerchantScopedRequest {
    staffId: StoreId;
}

export async function apiMerchantDeleteStaffMember(request: MerchantStaffRequest): Promise<any> {
    return apiClient.post("/merchant/delete_staff_member", request);
}